import  config  from '@/config/config';
export default config 